import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, Shield } from 'lucide-react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function PricingSection() {
  return <Section background="white" id="offer" data-id="element-120">
      <div className="max-w-5xl mx-auto" data-id="element-121">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-122">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-123">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-124">
              <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766519219/Oferta_Especial_n3ajpi.png" alt="Casa Impecable - Oferta Especial Navidad con ambiente acogedor" className="w-full h-auto" loading="lazy" data-id="element-125" />
            </div>
          </motion.div>

          {/* Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-126">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-[#D4AF37]/30" data-id="element-127">
              {/* Header */}
              <div className="bg-[#2C7A7B] text-white p-6 text-center" data-id="element-128">
                <h2 className="text-2xl md:text-3xl font-serif font-bold mb-2" data-id="element-129">
                  Oferta Completa de Navidad
                </h2>
                <p className="text-[#D4AF37] font-medium" data-id="element-130">
                  Disponible por tiempo limitado
                </p>
              </div>

              <div className="p-8" data-id="element-131">
                {/* Stack with Thumbnails */}
                <div className="space-y-4 mb-8" data-id="element-132">
                  <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl" data-id="element-133">
                    <div className="flex items-center gap-3" data-id="element-134">
                      <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766518194/Caratula_Libro_Casa_impecable_aeltbs.png" alt="Ebook Casa Impecable" className="w-12 h-auto rounded shadow-md" data-id="element-135" />
                      <span className="font-medium text-gray-700" data-id="element-136">
                        Ebook Casa Impecable
                      </span>
                    </div>
                    <span className="font-bold text-gray-400 line-through" data-id="element-137">
                      $27.97
                    </span>
                  </div>

                  <div className="flex items-center justify-between p-4 bg-[#FFF9F5] rounded-xl border border-[#D4AF37]/20" data-id="element-138">
                    <div className="flex items-center gap-3" data-id="element-139">
                      <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766517815/Bono_1_portada_-_checklist_bwom8l.png" alt="Bono 1" className="w-12 h-auto rounded shadow-md" data-id="element-140" />
                      <span className="font-medium text-gray-700 text-sm" data-id="element-141">
                        Bono 1: Sistema Antirresbalones
                      </span>
                    </div>
                    <span className="font-bold text-[#FF6B6B]" data-id="element-142">GRATIS</span>
                  </div>

                  <div className="flex items-center justify-between p-4 bg-[#FFF9F5] rounded-xl border border-[#D4AF37]/20" data-id="element-143">
                    <div className="flex items-center gap-3" data-id="element-144">
                      <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766517816/Bono_2_caratula_Antidoto_oo7xtb.png" alt="Bono 2" className="w-12 h-auto rounded shadow-md" data-id="element-145" />
                      <span className="font-medium text-gray-700 text-sm" data-id="element-146">
                        Bono 2: Antídoto Contra la Culpa
                      </span>
                    </div>
                    <span className="font-bold text-[#FF6B6B]" data-id="element-147">GRATIS</span>
                  </div>

                  <div className="flex items-center justify-between p-4 bg-[#FFF9F5] rounded-xl border border-[#D4AF37]/20" data-id="element-148">
                    <div className="flex items-center gap-3" data-id="element-149">
                      <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766517815/Bono_3_-_La_Compaera_q32bk6.png" alt="Bono 3" className="w-12 h-auto rounded shadow-md" data-id="element-150" />
                      <span className="font-medium text-gray-700 text-sm" data-id="element-151">
                        Bono 3: La Compañera Invisible
                      </span>
                    </div>
                    <span className="font-bold text-[#FF6B6B]" data-id="element-152">GRATIS</span>
                  </div>
                </div>

                {/* Price Display */}
                <div className="text-center mb-8" data-id="element-153">
                  <p className="text-gray-500 text-sm mb-2" data-id="element-154">
                    Valor total real:{' '}
                    <span className="line-through" data-id="element-155">$97.86</span>
                  </p>
                  <div className="flex items-center justify-center gap-4 mb-2" data-id="element-156">
                    <span className="text-2xl text-gray-400 line-through font-medium" data-id="element-157">
                      $27.97
                    </span>
                    <span className="text-5xl md:text-6xl font-bold text-[#2C7A7B]" data-id="element-158">
                      $12.97
                    </span>
                  </div>
                  <p className="text-[#FF6B6B] font-bold text-lg" data-id="element-159">
                    ¡Ahorras $15.00 hoy!
                  </p>
                </div>

                {/* CTA */}
                <div className="flex flex-col items-center gap-4" data-id="element-160">
                  <Button size="xl" fullWidth withPulse className="shadow-xl shadow-[#FF6B6B]/20" data-id="element-161">
                    Sí, quiero mi casa impecable + 3 bonos
                  </Button>
                  <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500" data-id="element-162">
                    <span className="flex items-center gap-1" data-id="element-163">
                      <Shield className="w-3 h-3" data-id="element-164" /> Pago Seguro
                    </span>
                    <span data-id="element-165">•</span>
                    <span data-id="element-166">Descarga Inmediata</span>
                    <span data-id="element-167">•</span>
                    <span data-id="element-168">Acceso de por vida</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </Section>;
}